import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ConfigParamsService } from './services/configParameters/config-params.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  private config = null;
  constructor(private translate: TranslateService,
    private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer, private configParamsService: ConfigParamsService) {
    translate.addLangs(['ca','es']);
    translate.setDefaultLang('ca');
    translate.use('ca');
    iconRegistry.addSvgIcon('new_featureIcon', sanitizer.bypassSecurityTrustResourceUrl('assets/mapIcons/ic_new_Fotodenuncia.svg'));
     this.config = this.configParamsService.getConfig();
    if (!this.config) {
      this.configParamsService.getConfigFile('global').then(data => {
        this.config = data;
        if(this.config.lang && this.translate.getLangs().indexOf(this.config.lang) >= 0){
          this.translate.use(this.config.lang);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/app.component.ts